import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { CareType } from 'src/app/models/care-type.model'
import { SocialService } from 'src/app/models/SocialService'
import { CodeListService } from './CodeListService'

@Injectable({
  providedIn: 'root',
})
export class CareTypeService extends CodeListService<CareType> {
  recordClass = CareType

  constructor() {
    super()
  }

  getForSocialServiceType(socialServiceTypeId: number): Observable<CareType[]> {
    return this.feathers.find(CareType, { socialServiceTypeId })
  }

  /**
   * Resolves care types for the tenant's social service instance (active allocation's socialServiceId).
   */
  getCareTypesForActiveSocialServiceId(socialServiceId: number | null | undefined): Observable<CareType[]> {
    if (socialServiceId == null) {
      return of([])
    }
    return this.feathers.find(SocialService, { id: socialServiceId }).pipe(
      switchMap((services) => {
        const socialServiceTypeId = services[0]?.socialServiceTypeId
        return socialServiceTypeId != null
          ? this.getForSocialServiceType(socialServiceTypeId)
          : of([])
      }),
    )
  }
}
